// extracted by mini-css-extract-plugin
export var integrationButton = "_aj-0";